<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top: 1.5em; font-size: 150%"><a id="title"></a></div>
<h1 class="title">The Courtesy of Death</h1>
<h2 class="author">Geoffrey Household</h2>
<p class="logo"><img alt="" src="html/docimages/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_title.vue?a96174a2